module.exports = __webpack_public_path__ + "img/art-review.b5a569a7.png";